
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/jira",
      function () {
        return require("private-next-pages/destinations/jira.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/jira"])
      });
    }
  